import { AccessLevelDisplayNames } from "@custom-types/project-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Returns the label of the current value to render in the select component */
export function getAccessLevelValue(
  accessLevel: FaroCoreApiTypes.ProjectAccessLevel
): string {
  return AccessLevelDisplayNames[accessLevel];
}

/** Access level descriptions */
export enum AccessLevelLDescription {
  private = "The project can only be seen by members who are signed in and invited.",
  unlisted = "The project can be seen by everyone with the link.",
}

/** Interface for a project access level item */
interface ProjectAccessLevelItem {
  /** Display label */
  label: string;

  /** Access level description */
  description: string;

  /** Access level value */
  value: FaroCoreApiTypes.ProjectAccessLevel;
}

/** Project access levels array */
export const PROJECT_ACCESS_LEVELS: ProjectAccessLevelItem[] = [
  {
    label: AccessLevelDisplayNames.private,
    description: AccessLevelLDescription.private,
    value: "private",
  },
  {
    label: AccessLevelDisplayNames.unlisted,
    description: AccessLevelLDescription.unlisted,
    value: "unlisted",
  },
];
